import { handleResponse, authHeader } from '../helpers'

export const adminSiteService = {
    get,
    update,
    getEmails,
    getChangePlanEmail,
    loadMetadata,
    cancelSubscription,
    resumeSubscription,
}

function get (id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/admin/site/${id}`, requestOptions).then(handleResponse)
}

function update ({id, params}) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/admin/site/${id}`, requestOptions).then(handleResponse)
}

function getEmails ({id, params}) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/admin/site/${id}/emails`, requestOptions).then(handleResponse)
}

function getChangePlanEmail ({id, params}) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }
    return fetch(`/admin/site/${id}/change-plan-email`, requestOptions).then(handleResponse)
}

function loadMetadata () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/admin/site/metadata`, requestOptions).then(handleResponse)
}

function cancelSubscription (id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/admin/site/${id}/cancel-subscription`, requestOptions).then(handleResponse)
}

function resumeSubscription (id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }
    return fetch(`/admin/site/${id}/resume-subscription`, requestOptions).then(handleResponse)
}
